export default {
  "AgreementCardThirdParty.CardName":
    "ドコモまたはドコモFGからのパートナーへの{linebreak}第三者提供",
  "AgreementCardThirdParty.CardDetail":
    "キャンペーン・クーポンなどをお届けするために、ドコモおよびドコモフィナンシャルグループからパートナーへパーソナルデータを提供させていただきます",
  "AgreementCardThirdParty.CardDetail2":
    "同意するを押下すると、提供範囲が以下に変更されます",
  "AgreementCardThirdParty.CardDetail3":
    "同意状況は、ドコモおよびドコモフィナンシャルグループで共通して適用されます",
}
